import {Injectable} from '@angular/core';
import {Category} from '../models/category.model';
import {DataServices} from './data.services';
import {State} from '../models/state.model';

@Injectable()
export class StatesService{


  states: State[] = [];

  constructor(private dataServices: DataServices){}

  getStates() {
    return this.dataServices.getStates();
  }

  setStates( states: State[]) {
    this.states =  states;
  }

}
